import type { QueryResultTable, SelectedSources } from "@/components/Chat/chat";

type Sources = {
  selected_sources?: SelectedSources;
};

const NO_EXPLANATION = "No explanation available.";
const NO_SQL_QUERY = "No SQL query available.";

export type FormattedSqlSources = {
  explanation: string;
  sql_query: string;
  /** One entry per SQL source that returned rows, in the same order as the
   * numbered explanations and queries above. Built by the backend at
   * serialization; absent for sources that returned nothing. */
  result_tables: QueryResultTable[];
};

export const formatSelectedSources = (
  sources: Sources,
): FormattedSqlSources => {
  const rawDataViews =
    sources?.selected_sources?.SQLAgentSchema ||
    sources?.selected_sources?.vivo_data_views;

  const dataViews =
    rawDataViews && !Array.isArray(rawDataViews)
      ? [rawDataViews]
      : rawDataViews;

  let formattedText = "";
  let formattedSQL = "";
  const resultTables: QueryResultTable[] = [];

  if (dataViews && Array.isArray(dataViews)) {
    dataViews.forEach((d, index) => {
      // Updated for backward compatibility
      const explanation = d.sql_explanation || d.explanation || NO_EXPLANATION;
      const sqlQuery = d.sql_query || d.citation?.sql_query || NO_SQL_QUERY;
      const table = d.citation?.query_result_table;
      if (table) resultTables.push(table);

      if (dataViews.length === 1) {
        formattedText += `${explanation}\n\n`;
        formattedSQL += `${sqlQuery}\n\n`;
      } else {
        formattedText += `${index + 1}. ${explanation}\n\n`;
        formattedSQL += `${index + 1}. ${sqlQuery}\n\n`;
      }
    });
  } else {
    formattedText = NO_EXPLANATION;
    formattedSQL = NO_SQL_QUERY;
  }

  return {
    explanation: formattedText,
    sql_query: formattedSQL,
    result_tables: resultTables,
  };
};
